"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdministratorType;
(function (AdministratorType) {
    AdministratorType[AdministratorType["Tenant"] = 1] = "Tenant";
    AdministratorType[AdministratorType["Domestic"] = 2] = "Domestic";
    AdministratorType[AdministratorType["International"] = 3] = "International";
})(AdministratorType || (AdministratorType = {}));
exports.default = AdministratorType;
